import {
  teachingOf,
  type GrammarTeaching,
} from "../content/lianxi/yufa-teaching.js";

/** The template publishes the same reviewed metadata as the canonical object. */
export function teachingOn(form: HTMLFormElement): GrammarTeaching | undefined {
  return teachingOf(
    JSON.parse(form.dataset["cbYufaTeaching"] ?? "null") as unknown,
  );
}
